import { useRoute } from 'vue-router'
import type { FeedbackTopic } from '../../../core/models/feedback-topic'
import useGet from '../../../core/composables/api/useGet'
import { computed, toValue, watch, type MaybeRef } from 'vue'
import { useEventBus } from '@vueuse/core'
import { EventKey } from '../../../core/events/event-key'
import type { SurveySelectionPreview } from '@/modules/profile/composables/use-evaluation-profile'

export const usePreparePulseSlide = (feedbackTopicId: MaybeRef<string>) => {
  const route = useRoute()

  const url = computed(() => {
    return `dialog/prepare/${route.params.id}/pulse-slide/${toValue(feedbackTopicId)}`
  })

  const { data, load, status, reload } = useGet<DialogPulseSlide>(url)

  watch(
    url,
    () => {
      load()
    },
    { immediate: true },
  )

  const eventBus = useEventBus(EventKey.dialogSlideUpdated)
  eventBus.on(() => reload())

  return { data, status }
}

export interface DialogPulseSlide {
  readonly feedbackTopic: FeedbackTopic
  readonly surveys: ReadonlyArray<SurveySelectionPreview>
  readonly slideProperties: {
    readonly updatedAt: string | null
    readonly surveyIds: Array<string>
  }
}
